import styled, { css } from 'styled-components';
import { rem, darken } from 'polished';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1yo0all-0"
})(["border-radius:", ";display:inline-flex;justify-content:center;padding:", " ", " ", ";", ""], rem(4), rem(16), rem(32), rem(8), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && css(["background-color:", ";box-shadow:0 4px 8px rgba(0,0,0,0.125);"], darken(0.025, backgroundColor));
});
export default Container;